export const spreadsheetsES = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  'Delete Format': 'Delete Format',
  'Cancel': 'Cancel',
  'Query (Optional)': 'Query (Optional)',
  'Sort (Optional)': 'Sort (Optional)',
  'Columns': 'Columns',
  'Are you sure you wish to remove all fields?': 'Are you sure you wish to remove all fields?',
  'Are you sure you wish to remove all sort fields?': 'Are you sure you wish to remove all sort fields?',
  'Direction': 'Direction',
  'Ascending': 'Ascending',
  'Descending': 'Descending',
  'Failed to save formats': 'Failed to save formats',
};